import css from 'styled-jsx/css';
import { colors, screen } from 'components/styles/variables';

export default css`
  .vehicle-information {
    width: 100%;
    color: ${colors.BLACK};
  }

  .vehicle-info-title {
    text-transform: uppercase;
    text-align: left;
    font-size: 18px;
    font-weight: 700;
    margin-top: 20px;
    margin-bottom: 20px;
    padding-top: 28px;
  }

  @media (min-width: ${screen.smMin}) {
    .vehicle-info-title {
      margin-top: 0;
      font-size: 20px;
    }

    .vehicle-info:last-child {
      border-bottom: none;
    }

    .vehicle-info:nth-last-child(2) {
      border-bottom: none;
    }
  }

  .info-container {
    display: flex;
    justify-content: space-between;
    flex-flow: row wrap;
  }

  .vehicle-info {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 14px 0;
    border-bottom: 1px solid ${colors.G1};
    width: 100%;
  }

  @media (min-width: ${screen.smMin}) {
    .vehicle-info {
      width: 47%;
      padding: 19px 0px;
    }
  }

  .info-label {
    font-size: 16px;
    font-weight: 300;
  }

  @media (min-width: ${screen.smMin}) {
    .info-label {
      font-size: 18px;
    }
  }

  .info-data {
    font-size: 16px;
    font-weight: 600;
    text-align: right;
  }

  @media (min-width: ${screen.smMin}) {
    .info-data {
      font-size: 18px;
    }
  }
`;
